import { styled } from 'styled-components'

type ServiceContainerProps = {
    isEmpty: boolean
}

export const ServiceContainer = styled.div<ServiceContainerProps>`
    display: flex;
    align-items: ${props => props.isEmpty ? 'center' : 'flex-start'};
    overflow-y: hidden;
    overflow-x: auto;
    position: relative;
`

export const ServicesWrapper = styled.div`
    height: 100%;
    padding-bottom: ${props => `${props.theme.marginXXS}px`};
    display: flex;
    gap: ${props => `${props.theme.marginXS}px`};
`

type SelectedServiceIndicatorProps = {
    isSelected: boolean
}

export const SelectedServiceIndicator = styled.div<SelectedServiceIndicatorProps>`
    background-color: ${props => props.isSelected ? props.theme.colorFillSecondary : 'transparent'};
    border-radius: ${props => `${props.theme.borderRadius}px`};
    transition: all 200ms ease;
`
